import { render, staticRenderFns } from "./slideBarComponent.vue?vue&type=template&id=44fde741&scoped=true&"
import script from "./slideBarComponent.vue?vue&type=script&lang=js&"
export * from "./slideBarComponent.vue?vue&type=script&lang=js&"
import style0 from "./slideBarComponent.vue?vue&type=style&index=0&id=44fde741&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fde741",
  null
  
)

export default component.exports